var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1572_80511)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1016 17.3286V22.0404C33.1016 22.6107 33.5495 23.0731 34.1019 23.0731C34.6544 23.0731 35.1023 22.6107 35.1023 22.0404V17.3286C35.1023 16.7583 34.6544 16.2959 34.1019 16.2959C33.5495 16.2959 33.1016 16.7583 33.1016 17.3286Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8698 21.2743C28.3173 21.2743 27.8695 20.8119 27.8695 20.2416V18.4417C27.8695 17.8713 28.3173 17.4089 28.8698 17.4089C29.4222 17.4089 29.8701 17.8713 29.8701 18.4417V20.2416C29.8701 20.8119 29.4222 21.2743 28.8698 21.2743Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9951 37.6387C15.4427 37.6388 14.9949 38.1014 14.9951 38.6717C14.9953 39.2421 15.4433 39.7043 15.9958 39.7041L40.0035 39.696C40.556 39.6958 41.0037 39.2333 41.0035 38.663C41.0033 38.0926 40.5553 37.6304 40.0029 37.6306L38.0427 37.6312C38.3956 36.541 38.5866 35.3749 38.5866 34.1641C38.5866 28.1263 33.8456 23.2317 27.9972 23.2317C22.1487 23.2317 17.4077 28.1263 17.4077 34.1641C17.4077 35.3774 17.5995 36.5459 17.9538 37.638L15.9951 37.6387ZM30.1621 37.4808C30.1072 37.5358 30.0484 37.586 29.9865 37.6312H31.9118C32.0744 37.2533 32.1607 36.8428 32.1607 36.4234C32.1607 35.6129 31.8387 34.8356 31.2656 34.2625C30.6925 33.6893 29.9152 33.3674 29.1047 33.3674H25.8536C25.457 33.3674 25.0766 33.2098 24.7962 32.9294C24.5157 32.6489 24.3581 32.2685 24.3581 31.8719C24.3581 31.4753 24.5157 31.0949 24.7962 30.8144C25.0766 30.534 25.457 30.3764 25.8536 30.3764H30.4465C30.8056 30.3764 31.0967 30.0853 31.0967 29.7262V29.4661C31.0967 29.107 30.8056 28.8159 30.4465 28.8159H28.2594V27.8701C28.2594 27.511 27.9683 27.2199 27.6092 27.2199H27.3491C26.99 27.2199 26.6989 27.511 26.6989 27.8701V28.8159H25.8536C25.0431 28.8159 24.2658 29.1379 23.6927 29.711C23.1196 30.2841 22.7976 31.0614 22.7976 31.8719C22.7976 32.6824 23.1196 33.4597 23.6927 34.0328C24.2658 34.6059 25.0431 34.9279 25.8536 34.9279H29.1047C29.5013 34.9279 29.8817 35.0854 30.1621 35.3659C30.4426 35.6464 30.6002 36.0267 30.6002 36.4234C30.6002 36.82 30.4426 37.2004 30.1621 37.4808Z",
    fill: "#1D1B18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6661 27.3118C38.1136 27.3118 37.6658 26.8494 37.6658 26.279V22.1482C37.6658 21.5778 38.1136 21.1155 38.6661 21.1155C39.2186 21.1155 39.6664 21.5778 39.6664 22.1482V26.279C39.6664 26.8494 39.2186 27.3118 38.6661 27.3118Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_80511",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProfit);
export default __webpack_public_path__ + "static/media/Home_Profit.5fd8ddadc5f1852e2d0862090fdb66e7.svg";
export { ForwardRef as ReactComponent };